// extracted by mini-css-extract-plugin
export var animateCircle = "form-module--animate-circle--3pWkv";
export var bounce = "form-module--bounce--yVw7F";
export var buttonWrap = "form-module--buttonWrap--vTDTE";
export var checkboxLabel = "form-module--checkbox-label--EI8bi";
export var checkboxes = "form-module--checkboxes--Aa5Ne";
export var checkmark = "form-module--checkmark--f0ROm";
export var connectAgreement = "form-module--connectAgreement--70EGW";
export var description = "form-module--description--jshNn";
export var error = "form-module--error--XILSr";
export var formWrap = "form-module--formWrap--OydAZ";
export var input = "form-module--input--PAJP7";
export var item = "form-module--item--76-HM";
export var label = "form-module--label--3quMy";
export var ldsRing = "form-module--lds-ring--RND9w";
export var mainForm = "form-module--main-form--34aq0";
export var policy = "form-module--policy--II6kS";
export var submit = "form-module--submit--ky-Fq";